'use client';

import cx from 'classix';
import { useAtomValue } from 'jotai/index';

import {
  currenciesListAtom,
  currentCurrencyAtom,
} from '@/features/currency/atoms/currencies-atom';
import {
  type Listing,
  type ListingDataView,
} from '@/features/listing/types/listing-types';

import styles from './listing-rate.module.scss';

interface ListingRateProps {
  rate: Listing['rates'];
  view?: ListingDataView;
  showPerMonth?: boolean;
}

export default function ListingRate(props: ListingRateProps) {
  const {
    rate,
    showPerMonth = true,
    view = 'isCard',
  } = props;

  const currency = useAtomValue(currentCurrencyAtom);
  const currencies = useAtomValue(currenciesListAtom);
  let listingPrice = rate.requestedMonthlyRate;

  if (currencies && rate.requestedCurrency !== currency.name) {
    const listingCurrency = currencies[rate.currency];
    const listingPriceInUSD = rate.monthlyRate / listingCurrency.rate;
    listingPrice = listingPriceInUSD * currency.rate;
  }

  return (
    <div
      className={cx(
        styles.listingRate,
        styles[`listingRate__${view}`],
      )}
    >
      <div className={styles.listingRate_value}>
        {currency.prefix && (
          <div>{currency.prefix}</div>
        )}

        <div className={styles.listingRate_label}>
          {Math.ceil(listingPrice)}
        </div>

        {!currency.prefix && currency.postfix && (
          <div>{currency.postfix}</div>
        )}
      </div>

      {showPerMonth && (
        <div>
          {view === 'isDetailed' ? currency.name : `${currency.name} / month`}
        </div>
      )}
    </div>
  );
}
